import LocalStorageUtils from 'js/lib/LocalStorageUtils';
import { SAVE_SECTION_PATH, CLEAR_SECTION_PATH } from 'js/constants/actionTypes';
import { SectionKey } from 'new/state/sectionNavigation/types';

const STORAGE_KEY = 'nexla_section_navigation';

export interface SectionNavigationState {
  [key: string]: string;
}

/**
 * Save section path to Redux and localStorage
 */
export const saveSectionPath = (section: SectionKey, path: string) => {
  const state =
    (LocalStorageUtils.getObject(STORAGE_KEY) as SectionNavigationState | undefined) || {};
  state[section] = path;
  LocalStorageUtils.saveObject(STORAGE_KEY, state);

  return {
    type: SAVE_SECTION_PATH,
    payload: { section, path },
  };
};

/**
 * Clear section path from Redux and localStorage
 */
export const clearSectionPath = (section: SectionKey) => {
  const state =
    (LocalStorageUtils.getObject(STORAGE_KEY) as SectionNavigationState | undefined) || {};
  delete state[section];
  LocalStorageUtils.saveObject(STORAGE_KEY, state);

  return {
    type: CLEAR_SECTION_PATH,
    payload: { section },
  };
};
